import { useMutation } from 'react-query';
import api from 'services';
import { SuccessResponse } from 'services/requests';
import { MutationKeys } from 'constants/mutationKeys';

export const useLogout = () => {
  const mutate = async () => {
    const { data } = await api.logout();

    return data;
  };

  const mutationKey = MutationKeys.logout;

  return useMutation<SuccessResponse>(mutationKey, mutate, {
    onSuccess: () => api.logoutApp(),
    onError: () => api.logoutApp(),
  });
};
